import { styled } from '@linaria/react';

function ColorBox({ color }) {
  return (
    <BoxWrapper>
      <Box style={{ backgroundColor: color }} />
      <Label>{color}</Label>
    </BoxWrapper>
  );
}

function HSLColorsFromColorFormats() {
  return (
    <Wrapper>
      <ColorBox color="gray" />
      <ColorBox color="darkgray" />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  gap: 16px;
  padding: 0 16px;
  justify-content: center;
  width: 100%;
  margin-bottom: 32px;
`;

const BoxWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 100px;
  width: 150px;
  max-width: 150px;
`;

const Box = styled.div`
  width: 100%;
  min-height: 40px;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
`;

const Label = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3px;
  font-family: var(--font-family-mono);
  padding: 0px 8px;
`;

export default HSLColorsFromColorFormats;
